import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {Text} from "@mantine/core";
import {MeterReading} from "../types.ts";

export const useTableColumns = () => {

    const columns: DataTableColumn<MeterReading>[] = [
        {
            accessor: 'id',
            title: I18n.get('Record'),
            render: (record: MeterReading) => (
                <Text c="blue" style={{cursor: 'pointer'}}>
                    {record.id}
                </Text>
            ),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
        },
    ];

    return {
        columns,
    };
};
